import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import Event from '@js/components/stock_request/stock-request-event';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const mapToClientObject = stockRequest => {
    stockRequest.preferred_stock_transfer_date = moment(
        stockRequest.preferred_stock_transfer_date,
    ).format();

    return stockRequest;
};

const OPENED = 0;
const DECLINED = 1;
const REQUESTED = 2;
const APPROVED = 3;
const RECEIVED = 4;

export default {
    namespaced: true,
    state: {
        stockRequest: {
            id: null,
            name: null,
            reference_id: null,
            status: null,
            request_from_outlet_id: null,
            request_from_outlet: {
                id: null,
                name: null,
            },
            request_to_outlet_id: null,
            request_to_outlet: {
                id: null,
                name: null,
            },
            rejected_reason: null,
            approver: {
                id: null,
                name: null,
            },
            rejector: {
                id: null,
                name: null,
            },
            stocks: [],
        },
    },
    getters: {
        stockRequest: state => state.stockRequest,
        status: state => state.stockRequest.status,
        rejector: state => state.stockRequest.rejector,
        hasFinalized: state => state.stockRequest.status == RECEIVED,
        request_from_outlet: state => state.stockRequest.request_from_outlet,
        request_to_outlet: state => state.stockRequest.request_to_outlet,
        totalPrice: (state, getters) => {
            return getters.stocks
                .map(stock => {
                    const price = parseFloat(stock.price);
                    const quantity = parseFloat(stock.approved_quantity);
                    const validPrice = !_.isNaN(price) && !_.isNaN(quantity);
                    const totalPrice = validPrice ? price * quantity : 0;

                    return parseFloat(totalPrice.toFixed(2));
                })
                .reduce((a, c) => a + c, 0);
        },
        stocks: state => state.stockRequest.stocks,
        findStockIndex: (state, getters) => stock_id => {
            return getters.stocks.findIndex(s => s.stock_id == stock_id);
        },
    },
    mutations: {
        [types.SET_STOCK_REQUEST](state, stockRequest) {
            state.stockRequest = stockRequest;
        },

        [types.SET_STOCK_REQUEST_ATTR](state, { key, value }) {
            state.stockRequest[key] = value;
        },

        [types.ADD_REQUEST_STOCK](state, stock) {
            state.stockRequest.stocks.push(stock);
        },

        [types.REMOVE_REQUEST_STOCK](state, { index }) {
            state.stockRequest.stocks.splice(index, 1);
        },

        [types.UPDATE_REQUEST_STOCK](state, { index, key, value }) {
            state.stockRequest.stocks[index][key] = value;
        },
    },
    actions: {
        addRequestStock({ commit, getters }, stockInventory) {
            const stock = {
                stock_id: stockInventory.stock_id,
                name: stockInventory.name,
                sku: stockInventory.sku,
                barcode: stockInventory.barcode,
                source_outlet_stock: stockInventory,
                source_outlet_quantity: stockInventory.quantity,
                destination_outlet_quantity: null,
                destination_outlet_stock: null,
                requested_quantity: null,
                approved_quantity: null,
                received_quantity: null,
                remarks: null,
                price: stockInventory.cost,
            };

            commit(types.ADD_REQUEST_STOCK, stock);
        },

        removeRequestStock({ commit, getters }, stock_id) {
            const stockIndex = getters.findStockIndex(stock_id);

            if (stockIndex >= 0) {
                commit(types.REMOVE_REQUEST_STOCK, stockIndex);
            }
        },

        setStockRequestAttr({ commit }, { key, value }) {
            commit(types.SET_STOCK_REQUEST_ATTR, { key, value });
        },

        updateRequestStock({ commit, getters }, { stock_id, key, value }) {
            const index = getters.findStockIndex(stock_id);
            commit(types.UPDATE_REQUEST_STOCK, { index, key, value });
        },

        async getStockRequest({ dispatch, commit }, id) {
            const url = Laroute.route('stock_requests.show', { id });

            startLoading(dispatch, 'fetch-stock-request');

            try {
                const { data } = await axios.get(url);
                endLoading(dispatch, 'fetch-stock-request');
                commit(types.SET_STOCK_REQUEST, mapToClientObject(data));

                return data;
            } catch (e) {
                endLoading(dispatch, 'fetch-stock-request');
                throw e;
            }
        },

        async createStockRequest({ dispatch }, stockRequest) {
            const url = Laroute.route('stock_requests.store');

            startLoading(dispatch, 'save-stock-request');

            try {
                const { data } = await axios.post(url, stockRequest);
                endLoading(dispatch, 'save-stock-request');
                Event.$emit('stock-request-saved');

                return data;
            } catch (e) {
                endLoading(dispatch, 'save-stock-request');
                throw e;
            }
        },

        async updateStockRequest(
            { dispatch, getters, commit },
            { action, status = null },
        ) {
            const id = getters.stockRequest.id;
            const loader = `${action}-stock-request`;

            let url = 'stock_requests.update';

            if (status == APPROVED) {
                url = 'stock_requests.approve';
            } else if (status == RECEIVED) {
                url = 'stock_requests.receive';
            } else if (status == DECLINED) {
                url = 'stock_requests.reject';
            }

            const newStatus = status !== null ? { status } : {};

            startLoading(dispatch, loader);

            try {
                const { data } = await axios.put(
                    Laroute.route(url, { id }),
                    Object.assign({}, getters.stockRequest, newStatus),
                );

                commit(types.SET_STOCK_REQUEST, mapToClientObject(data));
                endLoading(dispatch, loader);
                Event.$emit('stock-request-saved');

                return data;
            } catch (e) {
                endLoading(dispatch, loader);
                throw e;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stock-request.js